



































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import { DxScrollView } from "devextreme-vue";

@Component({
  components: {
    DxPopup,
    DxToolbarItem,
    DxScrollView,
  },
})
export default class CustomPopup extends Vue {
  @Prop({ required: true })
  public title?: string;

  @Prop({ required: false, default: false })
  public show?: boolean;

  @Prop({ required: false, default: false })
  public showSave?: boolean;

  @Prop({ required: false, default: false })
  public showDelete?: boolean;

  @Prop({ required: false, default: false })
  public isEditing?: boolean;

  @Prop({ required: false, default: false })
  public saving?: boolean;

  @Prop({ required: false })
  public height?: number;

  @Prop({ required: false })
  public width?: number;

  @Prop({ required: false, default: false })
  public allowFullscreen!: boolean;

  fullscreen: boolean = false;

  public hide() {
    this.$emit("hide");
  }

  public save() {
    this.$emit("save", this.isEditing);
  }

  public remove() {
    this.$emit("delete");
  }
}
